import { useEffect, useState, useRef } from 'react';
import api from '../api/api';

const cache = {};

export default function useSoilTypes(year) {
  const [soilTypes, setSoilTypes] = useState([]);
  const abortController = useRef();

  useEffect(() => {
    if (abortController.current) {
      abortController.current.abort();
    }
    abortController.current = new AbortController();

    (async () => {
      if (cache[year]) {
        setSoilTypes(cache[year]);
      } else {
        const { signal } = abortController.current;
        const res = await api().fetchSoilTypes(year, signal);
        cache[year] = parseSoilTypes(year, res.data);
        setSoilTypes(cache[year]);
      }
    })();

    return () => {
      abortController.current.abort();
    };
  }, [year]);

  function getSoilTypeNameById(soilTypeId) {
    const soils = soilTypes.length ? soilTypes : cache[year] ?? [];
    const soil = soils.find((soilType) => soilType.id === soilTypeId);
    return soil?.names.de.toLowerCase();
  }

  function getSoilTypeNameByCode(soilTypeCode) {
    const soils = soilTypes.length ? soilTypes : cache[year] ?? [];
    const soil = soils.find((soilType) => soilType.code === soilTypeCode);
    return soil?.names.de.toLowerCase();
  }

  return { soilTypes, getSoilTypeNameById, getSoilTypeNameByCode };
}

export const SOIL_TYPE_CODES = {
  ALL: 'All',
};

function parseSoilTypes(year, soilTypes) {
  const newSoilTypes = soilTypes.sort((a, b) => a.names.de.localeCompare(b.names.de));

  const allSoilsOption = {
    id: `${year}.CL_ST.${SOIL_TYPE_CODES.ALL.toUpperCase()}`,
    names: {
      de: 'Alle Bodenarten',
    },
    code: SOIL_TYPE_CODES.ALL,
    status: 'ACTIVE',
  };

  return [allSoilsOption, ...newSoilTypes];
}
